import { useEffect, useMemo, useRef, useState } from "react";
import { Menu } from "primereact/menu";
import Button from "../../componentes/button/button";
import * as XLSX from "xlsx";

function TabelaFuncionario({ lista = [], loading, editar, visualizar }) {
    const [paginaAtual, setPaginaAtual] = useState(1);
    const itensPorPagina = 50;

    useEffect(() => {
        setPaginaAtual(1);
    }, [lista]);

    if (loading) {
        return (
            <div className="flex items-center justify-center py-16 text-muted-foreground gap-2">
                <i className="fa fa-spinner fa-spin text-xl text-primary" />
                <span className="text-sm">Carregando funcionários...</span>
            </div>
        );
    }

    if (!lista.length) {
        return (
            <div className="flex flex-col items-center justify-center py-16 text-muted-foreground gap-2">
                <i className="fa fa-users text-4xl opacity-20" />
                <p className="text-sm">Nenhum funcionário encontrado.</p>
            </div>
        );
    }

    const totalPaginas = Math.ceil(lista.length / itensPorPagina);

    const inicio = (paginaAtual - 1) * itensPorPagina;
    const fim = inicio + itensPorPagina;

    const listaPaginada = lista.slice(inicio, fim);

    return (
        <div className="overflow-x-auto rounded-xl border border-border min-h-[300px]">
            <table className="w-full text-xs">
                <thead>
                    <tr className="bg-table-header border-b border-table-border text-table-header-fg uppercase tracking-wide">
                        <th className="px-4 py-3 text-left font-semibold">Status</th>
                        <th className="px-4 py-3 text-left font-semibold">Nome/Cargo</th>
                        <th className="px-4 py-3 text-left font-semibold">Filial</th>
                        <th className="px-4 py-3 text-left font-semibold">Cód. Control</th>
                        <th className="px-3 py-3 text-center font-semibold">Mydash</th>
                        <th className="px-2 py-3 text-center font-semibold">Fortes RH</th>
                        <th className="px-2 py-3 text-center font-semibold">Trixlog</th>
                        <th className="px-2 py-3 text-center font-semibold">Ações</th>
                    </tr>
                </thead>
                <tbody className="divide-y divide-border bg-card">
                    {listaPaginada.map((f) => (
                        <tr key={f.id} className="hover:bg-table-row-hover transition-colors">
                            <td className="px-4 py-2.5">
                                {f.ativo
                                    ? <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-medium bg-success/10 text-success"><i className="fa fa-circle text-[6px]" />Ativo</span>
                                    : <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-medium bg-destructive/10 text-destructive"><i className="fa fa-circle text-[6px]" />Inativo</span>
                                }
                            </td>
                            <td className="px-4 py-2.5 font-medium text-foreground">
                                <div className="grid">
                                    {f.nome}
                                    <span className="font-light">
                                        {f.cargo || "—"}
                                    </span>
                                </div>
                            </td>
                            <td className="px-4 py-2.5 text-muted-foreground">{f.filialNome || "—"}</td>
                            <td className="px-4 py-2.5 text-muted-foreground">{f.codigoControl || "—"}</td>
                            <td className="px-2 py-2.5 text-center">
                                <SyncIcon ok={f.usuarioId ? true : false} />
                            </td>
                            <td className="px-2 py-2.5 text-center">
                                <SyncIcon ok={f.sincronizadoComFortes} />
                            </td>
                            <td className="px-2 py-2.5 text-center">
                                <SyncIcon ok={f.sincronizadoComTrixlog} />
                            </td>
                            <td className="px-4 py-2.5 text-center">
                                <i className="fa fa-edit text-foreground text-md px-2 py-1 rounded-md bg-muted hover:bg-muted/70 transition-colors duration-150 cursor-pointer" onClick={() => editar(f)} />
                                <i className="fa fa-eye text-foreground text-md px-2 py-1 bg-muted hover:bg-muted/70 transition-colors duration-150 rounded-md ml-3 cursor-pointer" onClick={() => visualizar(f)} />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <div className="px-4 py-3 border-t border-border bg-muted flex items-center justify-between">

                <div className="text-xs text-muted-foreground">
                    {lista.length} funcionário{lista.length !== 1 ? "s" : ""} encontrado{lista.length !== 1 ? "s" : ""}
                </div>

                <div className="flex items-center gap-2">

                    <Button
                        variant="gray"
                        disabled={paginaAtual === 1}
                        onClick={() => setPaginaAtual(prev => prev - 1)}
                        iconLeft="fa fa-chevron-left"
                    />

                    <span className="text-xs text-muted-foreground">
                        Página {paginaAtual} de {totalPaginas}
                    </span>

                    <Button
                        variant="gray"
                        disabled={paginaAtual === totalPaginas}
                        onClick={() => setPaginaAtual(prev => prev + 1)}
                        iconLeft="fa fa-chevron-right"
                    />
                </div>
            </div>
        </div>
    );
}

export default TabelaFuncionario;

function SyncIcon({ ok }) {
    return ok
        ? <i className="fa fa-check-circle text-success text-base" title="Sincronizado" />
        : <i className="fa fa-exclamation-circle text-destructive/70 text-base" title="Não sincronizado" />;
}